import Vue from "vue";

export default {
  recuperarTiposEndereco() {
    return Vue.axios.get("tipoEndereco");
  },
};